import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    comicId: 0,
    comicData: null,
    maxComicId: 0,
    comicLoadState: 'loading',
    errors: {
      voteError: '',
      comicLoadError: ''
    }
  },
  mutations: {
    setComicLoadState (state, loadState) {
      state.comicLoadState = loadState
    },
    updateComicData (state, data) {
      if (data === null) {
        state.comicData = null
        return
      }
      state.comicData = {
        comic: data.comic,
        originPost: data.origin_post,
        posts: data.posts
      }
      state.comicId = parseInt(data.comic.pk_comic_id)
      state.maxComicId = data.max_id
    },
    setError (state, error) {
      const newErrors = {
        ...state.errors
      }
      newErrors[error.type] = error.message
      state.errors = newErrors
    },
    user (state, user) {
      state.user = user
    },
    newPost (state, post) {
      state.comicData.posts.push(post)
    },
    deletePost (state, postId) {
      state.comicData.posts = state.comicData.posts.filter(p => p.pk_post_id !== postId)
    },
    modifyVoteCount (state, voteData) {
      const amount = parseInt(voteData.amount)
      const postId = parseInt(voteData.postId)
      const suggestions = state.comicData.posts
        .filter(p => p.type === 'suggestion')
      for (let s of suggestions) {
        if (parseInt(s.pk_post_id) === parseInt(postId)) {
          s.votes = parseInt(s.votes) + parseInt(amount)
          s.user_vote = amount === 1 ? '1' : '0'
        }
      }
    },
    lockComic (state, _) {
      state.comicData.comic.is_locked = true
    }
  },
  actions: {
    getComic (context, newId) {
      context.commit('setComicLoadState', 'loading')
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.API_URL + '/getcomic.php?id=' + newId).then(res => {
          if (res.body.status === 'success') {
            context.commit('updateComicData', res.body.data)
            context.commit('setComicLoadState', 'success')
            resolve(res.body.data)
          } else {
            context.commit('setComicLoadState', 'error')
            context.commit('updateComicData', null)
            context.commit('setError', {
              type: 'comicLoadError',
              message: res.body.data
            })
            reject(res.body.data)
          }
        })
      })
    },
    changeComic (context, newId) {
      if (!newId) {
        newId = 0
      }
      context.dispatch('getComic', newId)
    },
    postVote (context, postId) {
      return new Promise((resolve, reject) => {
        Vue.http.post(process.env.API_URL + '/vote.php?post=' + postId).then(res => {
          if (res.body.status === 'success') {
            context.commit('modifyVoteCount', {
              postId: postId,
              amount: res.body.data
            })
            resolve()
          } else {
            reject(res.body.data)
          }
        })
      })
    },
    createPost (context, newPost) {
      return new Promise((resolve, reject) => {
        Vue.http.post(process.env.API_URL + '/newpost.php', {
          text: newPost.text,
          type: newPost.type,
          comicId: newPost.comicId
        }).then((response) => {
          if (response.body.status === 'success') {
            context.commit('newPost', response.body.data)
            resolve()
          } else {
            reject(response.body.data)
          }
        })
      })
    },
    loginUser (context, loginData) {
      return new Promise((resolve, reject) => {
        context.commit('user', loginData)
        localStorage.setItem('jwt', loginData.jwt)
        resolve()
      })
    },
    logoutUser (context, _) {
      return new Promise((resolve, reject) => {
        context.commit('user', null)
        localStorage.removeItem('jwt')
        resolve()
      })
    },
    deletePost (context, postId) {
      return new Promise((resolve, reject) => {
        Vue.http.post(process.env.API_URL + '/deletepost.php', {
          postId: postId
        }).then((response) => {
          if (response.body.status === 'success') {
            context.commit('deletePost', postId)
            resolve()
          } else {
            reject(response.body.data)
          }
        })
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js